export const agent = {
yqmh: "邀請盲盒",
 yqzmh: "邀請賺盲盒",
 bfbkj: "100%開獎",
 yqpy: "邀請朋友",
 pywczcrw: "朋友註冊並完成任務",
 hdcmhcs: "獲得抽盲盒次數",
 jllb: "獎勵清單",
 mhjlbk: "盲盒獎勵可能包括：{text}具體金額根據實際獲得獎勵為準！",
 kkcs: "可開{value}次",
 mhmx: "盲盒明細",
 jpmx: "獎品明細",
 hdmhs: "取得盲盒數",
 hyjd: "好友進度",
 jplx: "獎品類型",
 dbmc: "代幣名稱",
 ypf: "已派發",
 wpf: "未發放",
 lq: "領取",
 zblw: "週邊禮物",
 gxczmh: "恭喜抽中{amount},邀請新人好友,完成任務,取得盲盒",
 lxkflq: "週邊禮品獎勵請聯絡客服取得",
 shdz: "收貨地址",
 rwmc: "任務名稱",
 wczt: "完成狀態",
 hdmhsl: "取得盲盒數量",
 zblqdz: "週邊領取地址",
 shr: "收貨人",
 dh: "電話",
 xxdz: "詳細地址",
 yqmhhdgz: "邀請盲盒活動規則",
 yqyl: "一、什麼是Biking邀請有禮？",
 yhhkxt: "Biking邀請有禮是Biking用戶回饋系統，旨在回饋所有認同Biking、並邀請好友加入Biking的忠實用戶。",
 yqhyhdfhjl: "Biking邀請有禮簡單易用，用戶只需邀請好友，即可獲得豐厚獎勵。",
 cyhdhqjl: "二、參與活動完成任務能獲得什麼獎勵？",
 hywcrwhdjl: "邀請人邀請好友，好友完成對應任務，邀請人和受邀人都可獲得盲盒並開盲盒獲得獎勵。",
 mhhdgz: "三、盲盒獲得規則",
 syrwczc: "1.受邀者完成註冊和實名－受邀人獲得1次開啟機會",
 syrcz: "2.受邀人儲值≥100USDT－邀請人及受邀人各獲得1次開啟機會",
 syrcssxf: "3.受邀人合約手續費產生≥30USDT－邀請人和受邀人各獲得2次開啟機會",
 qqjyl: "4.選擇權交易量≥200USDT－邀請人及受邀人各獲得2次開啟機會",
 yxjyl: "5.Gamefi交易量≥200USDT且訂單賠率不低於1.2倍，低於1.2倍賠率訂單不統計－邀請人和受邀人各獲得2次開啟機會",
 xhmrjyl: "6.現貨買進交易量≥500USTD－邀請人和受邀者各獲得1次開啟機會",
 rwqbwc: "每次邀請任務全部完成邀請者最多可獲得8個開啟盲盒機會，受邀者達成最多可獲得9個開啟盲盒機會。邀請多人，獲得盲盒機會依規則累積增加。",
 qtsm: "四、其他說明",
 mhffsj: "1.盲盒發放時間--每10分鐘刷新",
 jlffsj: "2.獎勵發放時間--後台人工每日中午12點派發一次",
 syyhjkcj: "3.所有使用者皆可參加，及其他活動不衝突",
 mhcjs: "4.盲盒抽獎次數每月1號清零",
 yqmts: "只邀請使用者成為下級，下級交易為您產生手續費返傭",
 fym: "返傭碼",
 fymts: "邀請並直接給下級用戶開通不高於自身的返傭比例，下級交易按比例分配手續費返傭",
 szfym: "設定返傭碼",
 xzfym: "新增返傭碼",
 lj: "連結",
 fybl: "返傭比例",
 yyqhys: "已邀請好友數",
 sykcjs: "剩餘可創建",
 tjlx: "推薦類型",
 bwjs: "5.若發現任何個人及團隊存在套刷盲盒福利情況，幣王保留扣除及取消帳戶福利資格權益。所有參與此福利用戶視為接受官方福利條款，幣王交易所保留最終解釋權。",
 swmr: "設為預設",
 cffym: "返傭碼重複，請輸入正確的返傭碼",
 qxtjfym: "請先加上返傭碼",
 xywdbl: "10 <= 我的返傭比例",
 qsrdybl: "請輸入對應比例",
 qsrzqsl: "請輸入正確數值",
 qsrbz: "請輸入備註",
 bnbhzf: "不能包含特殊字元或表情",
 pfjj: "派發被拒絕",
 pfsb: "獎勵派發失敗",
 lxkf: "詳情請洽客服",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/tw.js